// extracted by mini-css-extract-plugin
module.exports = {"button":"EABDButton_button__1geOL","largerFontSize":"EABDButton_largerFontSize__1v6Nk"};